import React from 'react';
import { useQuery } from 'react-query';
import { Link } from 'redux-little-router';
import * as PropTypes from 'prop-types';
import { routeMap } from 'router/routes';
import RelativeLoading from 'components/Loading/RelativeLoading';
import { apiResponseWrapper } from 'utils/apiResponseWrapper';
import { ArmyMeasures } from './components/ArmyMeasures';
import { getArmyPrivileges } from './ArmyMobilizedSupportServices';
import styles from './ArmyMobilizedSupport.module.scss';
import config from 'config';

export default function ArmyMobilizedSupport() {
  const { isFetching, data: privileges } = useQuery('getArmyPrivileges', async () => {
    return apiResponseWrapper(await getArmyPrivileges());
  });

  const withoutMeasures =
    !privileges ||
    (privileges?.measuresForPP.length === 0 &&
      privileges?.measuresForIE.length === 0 &&
      privileges?.measuresForLE.length === 0);

  return (
    <div className={styles.root}>
      <div className="d-flex align-items-center justify-content-between">
        <h2>Меры поддержки в связи с частичной мобилизацией</h2>
        {config.isInspectorArm ? null : (
          <div className="link link_attention-red">
            <Link href={routeMap.requestArmyMeasures}>Сообщить об отсутствии мер поддержки</Link>
          </div>
        )}
      </div>
      {isFetching && <RelativeLoading />}
      {withoutMeasures && (
        <div className={styles.placeholder}>
          <span className={styles.text}>
            Пока нет информации. Здесь будут отображаться сведения о мерах поддержки в связи с
            частичной мобилизацией. Вы можете
            {config.isInspectorArm ? (
              ' сообщить'
            ) : (
              <a href={routeMap.requestArmyMeasures}> сообщить</a>
            )}{' '}
            об отсутствии мер поддержки
          </span>
        </div>
      )}
      {privileges?.measuresForPP.map((measures, i) => (
        <ArmyMeasures key={measures?.dateToArmy || i} {...measures} persona="физического лица" />
      ))}
      {privileges?.measuresForIE.map((measures, i) => (
        <ArmyMeasures
          key={measures?.dateToArmy || i}
          {...measures}
          persona="индивидуального предпринимателя"
        />
      ))}
      {privileges?.measuresForLE.map(({ periods = [] }, i) =>
        periods?.map((measures) => (
          <ArmyMeasures
            key={measures?.dateToArmy || i}
            {...measures}
            persona={`руководителя юридического лица${
              measures?.legalEntity ? ` ${measures.legalEntity}` : ''
            }`}
          />
        )),
      )}
    </div>
  );
}

ArmyMobilizedSupport.propTypes = {
  userInfo: PropTypes.object,
};
